/**
 * @generated SignedSource<<ed058e9226b59e079a14677e28155089>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AllStudentsFilterInput = {
  anyDiagnosticRetakeAssigned?: boolean | null | undefined;
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  lastDiagnosticCompletedFrom?: any | null | undefined;
  lastDiagnosticCompletedTo?: any | null | undefined;
  onlyWithOutstandingDiagnostic?: boolean | null | undefined;
  onlyWithResetDiagnostic?: boolean | null | undefined;
  siteIds?: ReadonlyArray<string> | null | undefined;
  studentEmailContains?: string | null | undefined;
  studentEmails?: ReadonlyArray<string> | null | undefined;
  studentNameContains?: string | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
};
export type IndividualStudentReportDataQuery$variables = {
  filter: AllStudentsFilterInput;
  id: string;
  skip: boolean;
  studentId: string;
};
export type IndividualStudentReportDataQuery$data = {
  readonly allStudents?: {
    readonly nodes: ReadonlyArray<{
      readonly firstName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
      readonly publicUserId: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly currentTargetGroupByStudentId: {
    readonly targetGroup: {
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly latestCompletedStudentSkillDiagnostic: {
    readonly id: string;
    readonly isInferred: boolean;
    readonly retakeAssigned: boolean;
  } | null | undefined;
  readonly studentById: {
    readonly firstName: string | null | undefined;
    readonly id: string;
    readonly lastName: string | null | undefined;
    readonly publicUserId: string | null | undefined;
    readonly sites: ReadonlyArray<{
      readonly id: string;
    } | null | undefined> | null | undefined;
    readonly userClasses: ReadonlyArray<{
      readonly class: {
        readonly id: string;
        readonly name: string | null | undefined;
        readonly section: string | null | undefined;
      } | null | undefined;
      readonly id: string;
      readonly isActive: boolean;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type IndividualStudentReportDataQuery = {
  response: IndividualStudentReportDataQuery$data;
  variables: IndividualStudentReportDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "studentId"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "studentId",
      "variableName": "studentId"
    }
  ],
  "concreteType": "StudentSkillDiagnosticNode",
  "kind": "LinkedField",
  "name": "latestCompletedStudentSkillDiagnostic",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isInferred",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "retakeAssigned",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "studentId",
    "variableName": "id"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "TargetGroupNode",
  "kind": "LinkedField",
  "name": "targetGroup",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicUserId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": (v6/*: any*/),
  "concreteType": "Student",
  "kind": "LinkedField",
  "name": "studentById",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/),
    (v4/*: any*/),
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SiteNode",
      "kind": "LinkedField",
      "name": "sites",
      "plural": true,
      "selections": [
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserClassNode",
      "kind": "LinkedField",
      "name": "userClasses",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isActive",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ClassNode",
          "kind": "LinkedField",
          "name": "class",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v7/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "section",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "condition": "skip",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "filter"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        }
      ],
      "concreteType": "StudentConnection",
      "kind": "LinkedField",
      "name": "allStudents",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Student",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v4/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "IndividualStudentReportDataQuery",
    "selections": [
      (v5/*: any*/),
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "StudentTargetGroupNode",
        "kind": "LinkedField",
        "name": "currentTargetGroupByStudentId",
        "plural": false,
        "selections": [
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      (v12/*: any*/),
      (v13/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "IndividualStudentReportDataQuery",
    "selections": [
      (v5/*: any*/),
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "StudentTargetGroupNode",
        "kind": "LinkedField",
        "name": "currentTargetGroupByStudentId",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      (v12/*: any*/),
      (v13/*: any*/)
    ]
  },
  "params": {
    "cacheID": "e06bd6d23cde7ae4cfa035b5355b7a1d",
    "id": null,
    "metadata": {},
    "name": "IndividualStudentReportDataQuery",
    "operationKind": "query",
    "text": "query IndividualStudentReportDataQuery(\n  $studentId: ID!\n  $id: ID!\n  $filter: AllStudentsFilterInput!\n  $skip: Boolean!\n) {\n  latestCompletedStudentSkillDiagnostic(studentId: $studentId) {\n    id\n    isInferred\n    retakeAssigned\n  }\n  currentTargetGroupByStudentId(studentId: $id) {\n    targetGroup {\n      id\n      name\n    }\n    id\n  }\n  studentById(studentId: $id) {\n    firstName\n    lastName\n    id\n    publicUserId\n    sites {\n      id\n    }\n    userClasses {\n      id\n      isActive\n      class {\n        id\n        name\n        section\n      }\n    }\n  }\n  allStudents(filter: $filter, first: 1000) @skip(if: $skip) {\n    nodes {\n      id\n      firstName\n      lastName\n      publicUserId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c73eec07f9b75b90c22219bc941b281f";

export default node;
